module.exports = __webpack_public_path__ + "images/LargePrint_199bb8a.png";